<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="500">
        <v-form v-model="formData.valid" class="mb-3" validate-on="input" @submit.prevent="submitForm">
            <v-card>
                <v-card-title id="heading" class="d-flex justify-space-between">
                    <h4>Send Message to {{
                            device ? `Device "${device.slno}"` : `${deviceGroup ? `Device Group "${deviceGroup.label}"` : ''}`
                        }}</h4>
                    <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
                </v-card-title>

                <v-container>
                    <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                             density="compact" variant="tonal">
                        <p v-for="error in errors">{{ error }}</p>
                    </v-alert>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="formData['message']" autofocus :rules="[vRules.required]" label="Message"/>
                            <v-textarea v-model="formData['comments']" :rules="[vRules.required]" label="Comments"/>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions class="px-4 d-flex justify-end">
                    <v-btn size="small" type="button"
                           @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                    <v-btn :disabled="!formData.valid" color="primary" size="small" type="submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script setup>
import {ref, reactive} from "vue";
import {send} from "@/composables/apiClient";
import {useLoadingStore} from "@/stores/loadingStore";
import {useSnackbarStore} from "@/stores/snackBarStore";

const loadingStore = useLoadingStore();
const snackbar = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
    deviceGroup: Object,
    command: Object,
    device: Object,
});
const formData = reactive({
    valid: false,
    message: props.command?.command ?? null,
    comments: props.comments?.comments ?? null,
    device_group_id: props.deviceGroup?.id ?? null,
    device_id: props.command?.device_id ?? props.device?.id ?? null,
});
const emits = defineEmits(['update:modelValue', 'addMessage', 'updateMessage']);
const dialogSwitch = ref(props.modelValue);
const errors = ref([]);

const submitForm = () => {
    errors.value = [];
    loadingStore.showLoading(`${props.command ? 'Updating' : 'Creating'}...`, 'Please wait while we save your changes');
    send(`${props.command ? 'put' : 'post'}`, `admin/device-commands${props.command ? '/' + props.command.id : ''}`, formData)
        .then((response) => {
            snackbar.showSnackbar(response.data.message);
            if (response.data.success) {
                emits(`${props.command ? 'updateMessage' : 'addMessage'}`, response.data.data);
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response?.data?.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response?.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            snackbar.showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
        .finally(() => loadingStore.hideLoading());
}
</script>
